import { TQualityLevelInfo } from '../../types/qualityLevelInfo';

export function qualityLevelInfoReducer(state: TQualityLevelInfo): TQualityLevelInfo | null {
  return state || null;
}
